/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Saga",
  logo_name: "Circe",
  nickname: null,
  tagline: "No editing. No bottleneck. Just Storytelling.",
  description:
    "The storytelling studio for ,everyday historians transforming raw footage into structured long-form narratives.",
  ctaText: "Sign up for Updates",
  ctaLink: "#/signup",
  resumeLink:
    "https://drive.google.com/file/d/1ecfeM8pNH7aLELi5EINHrX8-jY5Uqb0q/view?usp=sharing",
  portfolio_repository: "https://github.com/anxchen",
};

const whatWeDo = {
  heading: "What we do?",
  subheading: "Bridge the editor-storyteller divide",
  paragraphs: [
    "We believe video editing should feel like a conversation.",
    "Oftentimes, filming to sharing videos can take days, weeks, and even years to review, edit, and release. For at-home creatives who want to create and share videos for fun, the need to organize hours of footage or learn a new editing software takes away from the main focus: Telling Stories.",
    "Who wants to spend hours editing when you could spend hours capturing memories instead? Not us. ✋🏼",
  ],
  socialsBanner: {
    message: "Follow our socials for the latest news.",
  },
};

const about = {
  title: "About Us.",
  introParagraphs: [
    "Inspired by home-videos that many families hold onto within their homes and even loose overtime. Hours of footage, decades of stories untold, personal stories, and inside jokes that fade away when there is no outlet to share and pass on the memories.",
    "Our team of family and friends want to empower other community historians to tell their stories, their way.",
  ],
  manifesto: {
    heading: "Not through shorts.",
    bodyLead:
      "We want to inspire greater meaning and connection by telling the",
    highlight: "whole story.",
  },
  videoSection: {
    introLead:
      "Follow along with our trials and tribulations using Saga to tell",
    introLinkText: "our stories.",
    introLinkHref: "https://www.youtube.com/channel/UC1Trt366nOZdzauxlorGWcQ",
    channelName: "Camp Cambrian",
    subscribeCta: "Subscribe",
    subscribeHref:
      "https://www.youtube.com/channel/UC1Trt366nOZdzauxlorGWcQ?sub_confirmation=1",
    embedUrl: "https://www.youtube.com/embed/mg9Dg9HdzW8",
  },
};

const signUpContent = {
  title: "Sign up for early access",
  subtitle:
    "We're welcoming a limited group of storytellers to help shape Saga. Share your email and we'll reach out with next steps.",
  subtitleLines: [
    "We're welcoming a limited group of storytellers to help shape Saga.",
    "Share your email and we'll reach out with next steps.",
  ],
  emailPlaceholder: "you@example.com",
  buttonText: "Join the waitlist",
  successMessage: "Thanks for signing up! We'll be in touch soon.",
};

const socialMediaLinks = [
  /*{
    name: "Github",
    link: "https://github.com/anxchen",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Gmail",
    link:
      "https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=tasinmiftaulmannan@gmail.com&subject=MISSED%20CALL%20EZTRADER&body=Hello",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/tasinmiftaulmannan",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  */
  {
    name: "YouTube",
    link:
      "https://www.youtube.com/channel/UC1Trt366nOZdzauxlorGWcQ?view_as=subscriber",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/campcambrian/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "X",
    link: "https://x.com/Saga_it_now",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
];

export { settings, greeting, whatWeDo, about, signUpContent, socialMediaLinks };
